import React, { Fragment } from 'react';
import { Form as FinalForm, Field, FormSpy } from 'react-final-form';
import {
  Alert,
  Button,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  HelpBlock,
  InputGroup,
  Panel,
} from 'react-bootstrap';
import ReactSelect from 'react-select3';
import _ from 'lodash';
import { FORM_ERROR } from 'final-form';

export default function ECFExternalMailboxEditForm({ settings, onSaveSettings, onCancel}) {
  if (! settings ) return null;

  return <FinalForm
    onSubmit={ onSaveSettings || alert }
    initialValues={ settings || {} }
    render={({form, submitting, pristine, values}) => (
      <Form>
        <FormGroup>
          <ControlLabel>Mail Provider / Type of server</ControlLabel>
          <FormControl.Static componentClass="div" style={{zIndex: 1000, position:'relative'}}>
            <Field
              name="type"
              component={FinalFormReactSelectAdapter}
              placeholder="Select your mail provider or server type"
              autoFocus
              defaultMenuIsOpen={ ! settings.id }
              isDisabled={ settings.id } // Don't allow type to be changed on existing settings
              options={[
                { label: <span><i className="fa fa-google"   /> GMail                </span>, value: 'gmail'   },
                { label: <span><i className="fa fa-envelope" /> Outlook365 / Hotmail </span>, value: 'hotmail' },
                { label: <span><i className="fa fa-envelope" /> IMAP                 </span>, value: 'imap'    },
              ]}
              clearable={false}
            />
          </FormControl.Static>
        </FormGroup>
        {/* Wait for type selection before showing any config opitons */}
        {!!_.get(values, 'type') &&
        <Fragment>
          {_.get(values, 'type') === 'gmail' &&
          <Alert bsStyle="warning">
            The following adjustments are needed to connect to GMail with your username and password:
            <ul>
              <li>Enable IMAP access in your {' '}
                <a
                  href="https://mail.google.com/mail/u/0/#settings/fwdandpop"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  GMail Forwarding and POP/IMAP settings
                  { ' ' }<i className="fa fa-external-link" />
                </a>.
              </li>
              <li>
                It may also be necessary to {' '}
                <a
                  href="https://myaccount.google.com/lesssecureapps"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Allow "less secure apps"
                  { ' ' }<i className="fa fa-external-link" />
                </a>.

              </li>
            </ul>
            <p>
              Rest assured that you mailbox information is kept safe: all usernames and passwords are stored encrypted,
              and our connection to GMail is secured using bank-grade SSL protocol.
            </p>
          </Alert>}

          {/* Only need server config for generic IMAP */}
          {_.get(values, 'type') === 'imap' && <Panel>
            <Panel.Heading>
              <Panel.Title>
                Server Connection Settings
              </Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              <FormGroup>
                <ControlLabel>Server Address (Hostname)</ControlLabel>
                <InputGroup>
                  <InputGroup.Addon><i className="fa fa-server" /></InputGroup.Addon>
                  <Field name="connection_settings.hostname" component="input" type="input" className="form-control" />
                </InputGroup>
                <HelpBlock>
                  Examples: <code>imap.example.org</code>, <code>mail.example.org</code>.
                </HelpBlock>
              </FormGroup>

              <FormGroup>
                <ControlLabel>Server Port</ControlLabel>
                <InputGroup>
                  <InputGroup.Addon>#</InputGroup.Addon>
                  <Field name="connection_settings.port" component="input" type="text" className="form-control" />
                </InputGroup>
                <HelpBlock>
                  Examples: <code>143</code> (without SSL), <code>993</code> (with SSL)
                </HelpBlock>
              </FormGroup>

              <label>
                <Field name="connection_settings.ssl" component="input" type="checkbox" />
                {' '} Use SSL (Secure Connection)
              </label>

            </Panel.Body>

          </Panel>}


          <Panel>
            <Panel.Heading>
              <Panel.Title>
                Login Credentials
              </Panel.Title>
            </Panel.Heading>
            <Panel.Body>
              <FormGroup>
                <ControlLabel>Login</ControlLabel>
                <InputGroup>
                  <InputGroup.Addon><i className="fa fa-user" /></InputGroup.Addon>
                  <Field name="connection_secrets.username" component="input" type="text" className="form-control" />
                </InputGroup>
                <HelpBlock>
                  Server login name.
                  Examples: <code>jsmith</code>, <code>jsmith@example.org</code>, <code>jsmith@gmail.com</code>, <code>jsmith@hotmail.com</code>.
                </HelpBlock>
              </FormGroup>

              <FormGroup>
                <ControlLabel>Password</ControlLabel>
                <InputGroup>
                  <InputGroup.Addon><i className="fa fa-key" /></InputGroup.Addon>
                  <Field
                    name="connection_secrets.password"
                    autoFocus={ !! values.id } // auto focus the password when updating credentials
                    component="input"
                    type="password"
                    className="form-control"
                  />
                </InputGroup>
              </FormGroup>

            </Panel.Body>
          </Panel>
        </Fragment>}

        {/*<ButtonToolbar>*/}
        <Button
          bsStyle='link'
          // instead of type=submit, since we dont' want stray [Enter] to submit the form
          onClick={() => ( pristine || confirm('This will give up any changes') ) && onCancel()  }
          disabled={submitting }
        >
          Cancel
        </Button>

          <Button
            style={{float: 'right'}}
            bsStyle={ pristine ? 'default' : 'primary'}
            // instead of type=submit, since we dont' want stray [Enter] to submit the form
            onClick={() => form.submit() }
            disabled={submitting || pristine }
          >
            { submitting
              ? <i className="fa fa-link fa-spin" />
              : <i className="fa fa-link" />
            }{' '}
            Validate and Save
          </Button>
        {/*</ButtonToolbar>*/}


        {/*<pre>{ JSON.stringify(values, null, 2) }</pre>*/}
      </Form>
    )}/>;
}

// Clients need to return this from onSaveSettings handler to tell us there has been an error
ECFExternalMailboxEditForm.saveErrorSignal = error => ({ [FORM_ERROR]: error });



const FinalFormReactSelectAdapter = ({ input: {value, onChange}, options, ...rest }) => (
  <ReactSelect
    value={_.find(options, { value: value })}
    onChange={selectedOption => onChange(_.get(selectedOption, 'value'))}
    options={options}
    {...rest}
  />
);



// WEBPACK FOOTER //
// ./src/User/ECFMailboxes/ECFExternalMailboxEditForm.jsx